import React, { useState, useContext } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { AiOutlineClose } from 'react-icons/ai'
import _ from 'lodash'

import AppConfigContext from '../../../app_layout/app_config_context'
import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'
import showToastNotification from '../../../widgets/toastify'

const initialState = {
  showDetachProductModal: false,
  isDetachingProduct: false
}

const DetachProduct = ({ user, product, planId, onSuccess }) => {
  const { client } = useContext(AppConfigContext)
  const [state, setState] = useState(initialState)
  if (!user || !product) return null
  const handleDetach = () => {
    const requestBody = {
      co_user_id: user.user_id,
      product_id: planId,
      client_secret: Constants.CLIENT_SECRET
    }
    const body = _.pick(
      requestBody,
      ApiHelper(client, 'DETACH_PRODUCT').API_BODY
    )
    setState(prev => ({ ...prev, isDetachingProduct: true }))

    ApiHelper(client, 'DETACH_PRODUCT')
      .API(client, body)
      .then(res => {

        if (res?.status === Constants.CO_API.SUCCESS) {

          showToastNotification({
            message: res?.data?.message || 'User detached successfully',
            isSuccess: true
          })

          setState(prev => ({
            ...prev,
            showDetachProductModal: false
          }))

          if (onSuccess) {
            onSuccess(user.user_id)
          }

        } else {
          showToastNotification({
            message: res?.message || 'Something went wrong',
            isSuccess: false
          })
        }

      })
      .catch((err) => {
        console.error(err)

        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Something went wrong'

        showToastNotification({
          message,
          isSuccess: false
        })
      })
      .finally(() => {
        setState(prev => ({ ...prev, isDetachingProduct: false }))
      })
  }

  return (
    <>
      <Button
        size="sm"
        variant="outline-danger"
        onClick={() =>
          setState(prev => ({ ...prev, showDetachProductModal: true }))
        }
      >
        Detach
      </Button>
      <Modal
        show={state.showDetachProductModal}
        onHide={() =>
          setState(prev => ({ ...prev, showDetachProductModal: false }))
        }
        backdrop="static"
      >
        <Modal.Header>
          <div className="d-flex justify-content-between w-100">
            <Modal.Title>Detach user?</Modal.Title>
            <Button
              variant="link"
              className="p-0"
              onClick={() =>
                setState(prev => ({ ...prev, showDetachProductModal: false }))
              }
            >
              <AiOutlineClose size={20} />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to detach{' '}
          <span className='user-modal-info'>{user.name}</span>{' '}
          from{' '}
          <span className='user-modal-info'>{product.display_name}</span>?
          They will lose access immediately.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() =>
              setState(prev => ({ ...prev, showDetachProductModal: false }))
            }
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={handleDetach}
            disabled={state.isDetachingProduct}
          >
            {state.isDetachingProduct ? 'Detaching...' : 'Detach'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DetachProduct